const animTiming = {
  duration: 300,
  easing: 'ease-in-out',
};

const closingAnimation = (content) => [
  { height: content.offsetHeight + 'px', opacity: 1 },
  { height: 0, opacity: 0 },
];

const openingAnimation = (content) => [
  { height: 0, opacity: 0 },
  { height: content.offsetHeight + 'px', opacity: 1 },
];

export default class Accordion {
  constructor() {
    document.querySelectorAll('.js-acod').forEach((details) => {
      const summary = details.querySelector('.js-acod-trigger');
      const content = details.querySelector('.js-acod-content');
      if (!summary || !content) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        if (details.getAttribute('open') !== null) {
          const anim = content.animate(closingAnimation(content), animTiming);
          anim.onfinish = () => {
            details.removeAttribute('open');
          };
        } else {
          details.setAttribute('open', 'true');
          void content.offsetHeight;
          content.animate(openingAnimation(content), animTiming);
        }
      });
    });
  }
}
